import { createSlice } from '@reduxjs/toolkit'
import dayjs from 'dayjs'

import { parseCommissionPage, parseCommissionStats } from 'apps/agency/model/adapter'
import {
  type AgencyCommissionsFilters,
  agencyCommissionsFilterUpdated,
} from 'apps/agency/model/events'
import type { AgencyCommissionByPageItem } from 'shared/api/requests/agency/schemas'

import { fetchCommissionsByPage, fetchPagesWithCommissions } from './thunks'

interface AgencyCommissionsState {
  pages: ReturnType<typeof parseCommissionPage>
  pagesStats: ReturnType<typeof parseCommissionStats>
  commissionsByPage: AgencyCommissionByPageItem[]
  filters: AgencyCommissionsFilters
  fetchingPages: boolean
}

export const initialState: AgencyCommissionsState = {
  pages: [],
  pagesStats: [],
  commissionsByPage: [],
  filters: {
    startDate: dayjs().add(-6, 'month').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
  },
  fetchingPages: false,
}

const commissionsSlice = createSlice({
  name: 'agency/commissions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(agencyCommissionsFilterUpdated, (state, action) => {
        state.filters = action.payload
        state.commissionsByPage = []
      })
      .addCase(fetchPagesWithCommissions.pending, (state) => {
        state.fetchingPages = true
      })
      .addCase(fetchPagesWithCommissions.fulfilled, (state, action) => {
        state.pages = parseCommissionPage(action.payload.pages)
        state.pagesStats = parseCommissionStats(action.payload.commissions_stats)
        state.fetchingPages = false
      })
      .addCase(fetchPagesWithCommissions.rejected, (state) => {
        state.fetchingPages = false
      })
      .addCase(fetchCommissionsByPage.fulfilled, (state, action) => {
        state.commissionsByPage = [...state.commissionsByPage, ...action.payload.commissions]
      })
  },
})

export default commissionsSlice.reducer
